import { FormGroupValue } from '../../../../../../../../ui/gzForm/formGroup/types/form-group-value';
import _ from 'lodash';
import {
  ApplicationControlRuleTargetsAppInventory,
  ApplicationControlRuleTargetsProcesses,
  ApplicationControlRuleTargetsType,
  ApplicationInventoryItemResponse,
} from '@nirvana/shared/dtos/types/policies/common';
import { ComplexSuggestedItem } from '../../../../../../../../ui/gzComplexEnumList/types';

// convert rule targets form value by section to db value
export function convertRuleTargetsFormValueBySectionToDbValue(
  formValue: FormGroupValue,
  section: string,
  convertors: object
) {
  const targetsType = _.get(formValue, section + '.type', '');

  // convert specific processes
  if (targetsType === ApplicationControlRuleTargetsType.SPECIFIC_PROCESSES) {
    _.unset(formValue, section + '.appInventory');

    const processes = _.get(formValue, section + '.processes', []) as ApplicationControlRuleTargetsProcesses[];
    processes.forEach(process => {
      if (Array.isArray(process.context) && process.context.length > 0) {
        return;
      }
      process.context = 0;
    });
    _.set(formValue, section + '.processes', processes);
    return;
  }

  // convert app inventory
  if (targetsType === ApplicationControlRuleTargetsType.APPLICATIONS_INVENTORY) {
    _.unset(formValue, section + '.processes');

    let appInventory = _.get(formValue, section + '.appInventory', []) as string[];
    appInventory = appInventory.map(val => convertors[val]);
    _.set(formValue, section + '.appInventory', appInventory);
    return;
  }

  // clear section if type is not set
  _.unset(formValue, section);
}

// convertors for app inventory
export function convertAppInventoryRpcResponseDbValueToUiValue(
  value: ApplicationInventoryItemResponse
): ComplexSuggestedItem {
  return {
    value: value._id,
    label: value.name,
    type: value.type,
  };
}
export function convertAppInventoryPolicyDbValueToUiValue(
  value: ApplicationControlRuleTargetsAppInventory
): ComplexSuggestedItem {
  return {
    value: value.id,
    label: value.name,
    type: value.type,
  };
}
export function convertAppInventoryUiValueToPolicyDbValue(
  value: ComplexSuggestedItem
): ApplicationControlRuleTargetsAppInventory {
  return {
    id: value.value,
    name: value.label,
    type: value.type ?? 0,
  };
}
